import { CacheableState } from '@utils/cacheable-state';
import { Request } from '../../domain';

export interface RequestsState {
  allRequests: CacheableState<Array<any>>;
  createRequest: CacheableState<Array<any>>;
  editRequest: CacheableState<Array<any>>;
  exportRequests: CacheableState<Array<any>>;
  myRequests: CacheableState<Array<Request>>;
  requestById: CacheableState<Request>;
  myRequestsCount: CacheableState<number>;
}

export function requestsInitialState(): RequestsState {
  return {
    allRequests: initialDataSubState().allRequests,
    createRequest: initialDataSubState().createRequest,
    editRequest: initialDataSubState().editRequest,
    exportRequests: initialDataSubState().exportRequests,
    myRequests: initialDataSubState().myRequests,
    requestById: initialDataSubState().requestById,
    myRequestsCount: initialDataSubState().myRequestsCount,
  };
}
export function initialDataSubState(): RequestsState {
  return {
    allRequests: new CacheableState(),
    createRequest: new CacheableState(),
    editRequest: new CacheableState(),
    exportRequests: new CacheableState(),
    myRequests: new CacheableState(),
    requestById: new CacheableState(),
    myRequestsCount: new CacheableState(),
  };
}
